import { QueryParameter } from './query-parameter';
import { NoParams } from './no-params';

export enum AppWebRoute {
    Admin = '/admin',
    Agencies = '/admin/agencies',
    AgencyClients = '/agency/clients',
    AssetLibrary = '/assets/view',
    Brand = '/brand',
    BrandAgencyBrands = '/brand/agency/brands',
    BrandClientConnectionsPlatforms = `/brand/client/:${QueryParameter.ClientId}/connections/platforms`,
    BrandClientEngagementLocationActivity = `/brand/client/:${QueryParameter.ClientId}/engagement/location-activity`,
    BrandClientEngagementRegionGroupActivity = `/brand/client/:${QueryParameter.ClientId}/engagement/region-group-activity`,
    BrandClientEngagementTemplateUse = `/brand/client/:${QueryParameter.ClientId}/engagement/template-use`,
    BrandClientManageActivities = `/brand/client/:${QueryParameter.ClientId}/manage/activities`,
    BrandClientManageHashtags = `/brand/client/:${QueryParameter.ClientId}/manage/hashtags`,
    BrandClientManageLearnMenu = `/brand/client/:${QueryParameter.ClientId}/manage/learn-menu`,
    BrandClientManageLocations = `/brand/client/:${QueryParameter.ClientId}/manage/locations/locations`,
    BrandClientManageRegionsGroups = `/brand/client/:${QueryParameter.ClientId}/manage/regions-groups/regions-groups`,
    BrandClientManageTemplateCategories = `/brand/client/:${QueryParameter.ClientId}/manage/template-categories`,
    BrandClientManageUsers = `/brand/client/:${QueryParameter.ClientId}/manage/users/users`,
    BrandClientOverview = `/brand/client/:${QueryParameter.ClientId}/engagement/overview`,
    BrandClientStyle = `/brand/client/:${QueryParameter.ClientId}/style`,
    BrandClientStyleColors = `/brand/client/:${QueryParameter.ClientId}/style/colors`,
    BrandClientStyleFonts = `/brand/client/:${QueryParameter.ClientId}/style/fonts`,
    BrandClientStyleStyleGuide = `/brand/client/:${QueryParameter.ClientId}/style/style-guide`,
    BrandCommunicateSend = '/brand/communicate/send',
    BrandCommunicateSendReport = '/brand/communicate/send-report',
    BrandRoadmap = '/brand/roadmap',
    BuilderTemplateGallery = '/builderTemplateGallery',
    Connections = '/connect',
    ContentBuilder = '/contentBuilder',
    EmailBuilder = '/emailBuilder',
    Graphql = '/graphql',
    Home = '/',
    LocationDetails = '/locationDetails',
    Login = '/login',
    Logout = '/logout',
    Notifications = '/notifications',
    Overview = '/overview',
    Planner = '/planner',
    Privacy = '/privacy',
    Profile = '/profile',
    PublishEmail = '/publish/email',
    Reports = '/reports',
    ReportsLocationEmailCampaigns = `/reports/location/:${QueryParameter.LocationId}/email-campaigns`,
    ReportsLocationOverview = `/reports/location/:${QueryParameter.LocationId}/overview`,
    ReportsLocationPlatform = `/reports/location/:${QueryParameter.LocationId}/${QueryParameter.PlatformName}`,
    Scheduled = '/scheduled',
    SpecialRequests = '/specialRequests',
    Terms = '/terms',
    TryThis = '/trythis',
    TryThisWebinar = '/trythis/:webinarId',
}

export const AppWebRoutes = {
    ...AppWebRoute,
};
export type AppWebRoutes = {
    [AppWebRoute.Admin]: NoParams;
    [AppWebRoute.Agencies]: NoParams;
    [AppWebRoute.AgencyClients]: NoParams;
    [AppWebRoute.AssetLibrary]: NoParams;
    [AppWebRoute.Brand]: NoParams;
    [AppWebRoute.BrandAgencyBrands]: NoParams;
    [AppWebRoute.BrandClientConnectionsPlatforms]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientEngagementLocationActivity]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientEngagementRegionGroupActivity]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientEngagementTemplateUse]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientManageActivities]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientManageHashtags]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientManageLearnMenu]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientManageLocations]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientManageRegionsGroups]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientManageTemplateCategories]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientManageUsers]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientOverview]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientStyle]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientStyleColors]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientStyleFonts]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandClientStyleStyleGuide]: {
        [QueryParameter.ClientId]: string;
    };
    [AppWebRoute.BrandCommunicateSend]: NoParams;
    [AppWebRoute.BrandCommunicateSendReport]: NoParams;
    [AppWebRoute.BrandRoadmap]: NoParams;
    [AppWebRoute.BuilderTemplateGallery]: NoParams;
    [AppWebRoute.Connections]: {
        platform?: string;
        locationId?: string;
    };
    [AppWebRoute.ContentBuilder]: {
        template?: string;
        video?: string;
        print?: string;
    };
    [AppWebRoute.EmailBuilder]: {
        template?: string;
    };
    [AppWebRoute.Graphql]: NoParams;
    [AppWebRoute.Home]: NoParams;
    [AppWebRoute.LocationDetails]: NoParams;
    [AppWebRoute.Login]: NoParams;
    [AppWebRoute.Logout]: NoParams;
    [AppWebRoute.Notifications]: NoParams;
    [AppWebRoute.Overview]: NoParams;
    [AppWebRoute.Planner]: NoParams;
    [AppWebRoute.Privacy]: NoParams;
    [AppWebRoute.Profile]: NoParams;
    [AppWebRoute.PublishEmail]: {
        [QueryParameter.ClientId]?: string;
        [QueryParameter.LocationId]?: string;
        [QueryParameter.TemplateId]?: string;
        [QueryParameter.Origin]?: string;
    };
    [AppWebRoute.Reports]: NoParams;
    [AppWebRoute.ReportsLocationEmailCampaigns]: {
        [QueryParameter.LocationId]: string;
    };
    [AppWebRoute.ReportsLocationOverview]: {
        [QueryParameter.LocationId]: string;
    };
    [AppWebRoute.ReportsLocationPlatform]: {
        [QueryParameter.LocationId]: string;
        [QueryParameter.PlatformName]: string;
    };
    [AppWebRoute.Scheduled]: NoParams & {
        [QueryParameter.ClientId]?: string;
        [QueryParameter.LocationId]?: string;
    };
    [AppWebRoute.SpecialRequests]: NoParams;
    [AppWebRoute.Terms]: NoParams;
    [AppWebRoute.TryThis]: NoParams;
    [AppWebRoute.TryThisWebinar]: {
        webinarId: string;
    };
};
